import { Code, ConnectError } from '@connectrpc/connect'
import { useTranslation } from 'react-i18next'
import { useRouteError } from 'react-router'

import {
  LightModeSemanticColors,
  Spacing,
  fontSizes,
} from '@enechain/ecloud-designsystem'

const PAGE_UNAVAILABLE_KEY = 'common:error.pageUnavailable'

// 全画面エラーに届くのは主に query (read) の失敗。 共通の code map
// (`~/libs/mapConnectError`) は更新操作向けの文言 (再読み込みしてやり直す /
// 入力内容に誤り / 既に登録) を含み全画面エラーでは的外れになるため通さず、
// read でも意味の通る NotFound だけを出し分けて、それ以外は画面表示失敗の
// 汎用文言にする。 error.message (ConnectError なら `[code] raw`) は内部文字列・
// 英語を含むため出さない。
const pageErrorKey = (error: unknown): string =>
  error instanceof ConnectError && error.code === Code.NotFound
    ? 'common:connectError.notFound'
    : PAGE_UNAVAILABLE_KEY

export const ErrorLayout = (): React.ReactElement => {
  const { t } = useTranslation()
  const error = useRouteError()

  return (
    <div
      style={{
        padding: Spacing[8].value,
        backgroundColor: LightModeSemanticColors.Surface.primary.value,
        color: LightModeSemanticColors.Text.highEmphasis.value,
        minHeight: '100vh',
      }}
    >
      <h1
        style={{
          fontSize: fontSizes.lg.value,
          fontWeight: 'bold',
          marginBottom: Spacing[4].value,
        }}
      >
        {t('common:error.occurred')}
      </h1>
      <p
        style={{
          fontSize: fontSizes.sm.value,
          color: LightModeSemanticColors.Text.midEmphasis.value,
        }}
      >
        {t(pageErrorKey(error))}
      </p>
    </div>
  )
}
